export default __webpack_public_path__ + "img/course-maindish.b99be06a9bf38340728d9bb880b9aa35.png";